import { centsToFormattedDollars } from '@fruitful/fruitils';
import type {
    DeepPartial,
    MoneyMapRuleWithAccountDetails,
} from '@fruitful/types';
import { LabelRegular, XStack } from 'smoothie';

import { isGoalRuleMissingPositiveTargetBalance } from '../../utils/moneyMapUtils';

const TargetBalanceChip = ({
    targetBalanceCents,
}: {
    targetBalanceCents: number;
}) => (
    <XStack
        backgroundColor="$gray200"
        paddingHorizontal={10}
        paddingVertical={4}
        borderRadius={100}
        alignItems="center"
        flexShrink={1}
    >
        <LabelRegular color="$gray1100" numberOfLines={1}>
            {centsToFormattedDollars(targetBalanceCents, false)} target balance
        </LabelRegular>
    </XStack>
);

export const UpdateGoalChip = () => (
    <XStack
        backgroundColor="$orange300"
        paddingHorizontal={10}
        paddingVertical={4}
        borderRadius={100}
        alignItems="center"
        flexShrink={1}
    >
        <LabelRegular color="$orange1100" numberOfLines={1}>
            Update goal
        </LabelRegular>
    </XStack>
);

interface GoalRuleChipsProps {
    rule: DeepPartial<MoneyMapRuleWithAccountDetails>;
}

export const GoalRuleChips = ({ rule }: GoalRuleChipsProps) => {
    if (isGoalRuleMissingPositiveTargetBalance(rule)) return <UpdateGoalChip />;
    if (rule.targetBalanceCents != null && rule.targetBalanceCents > 0) {
        return (
            <TargetBalanceChip targetBalanceCents={rule.targetBalanceCents} />
        );
    }
    return null;
};
